import React, { useState } from 'react'

import { formatPhoneNumber } from 'utils/formatPhoneNumber'

import { CALLING_DURATION_OPTIONS } from '../../constants'
import type { Berth } from '../../types'
import { Dialog } from '../Dialog'

import styles from './index.module.css'

type Props = {
  berths: Berth[]
  defaultBerthId: string
  driverName: string | null
  driverPhone: string | null
  onOk: (bookingMinute: number, berthId: string) => void
  onCancel: () => void
  isLoading: boolean
}

export const CallingDialog: React.FC<Props> = ({
  berths,
  defaultBerthId,
  driverName,
  driverPhone,
  onOk,
  onCancel,
  isLoading,
}) => {
  const [bookingMinute, setBookingMinute] = useState<number | null>(null)
  const [selectedBerthId, setSelectedBerthId] = useState<string>(defaultBerthId)

  const handleOk = () => {
    if (bookingMinute != null) {
      onOk(bookingMinute, selectedBerthId)
    }
  }

  return (
    <Dialog
      onClose={onCancel}
      prevButtonProps={{
        label: 'キャンセル',
        onClick: onCancel,
        variant: 'cancel',
        disabled: isLoading,
      }}
      nextButtonProps={{
        label: 'OK',
        onClick: handleOk,
        variant: 'primary',
        disabled: bookingMinute == null || berths.length === 0 || !selectedBerthId || isLoading,
      }}
    >
      <p className={styles.title}>呼び出しますか？</p>

      <div className={styles.section}>
        <div className={styles.categoryLabel}>受付情報</div>
        <div className={styles.fieldList}>
          <div className={styles.fieldRow}>
            <span className={styles.fieldLabel}>ドライバー</span>
            <span className={styles.fieldValue}>{driverName || '未定'}</span>
          </div>
          <div className={styles.fieldRow}>
            <span className={styles.fieldLabel}>電話番号</span>
            <span className={styles.fieldValue}>
              {driverPhone ? formatPhoneNumber(driverPhone) : '未定'}
            </span>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.categoryLabel}>
          バース<span className={styles.required}>*</span>
        </div>
        <select
          className={styles.select}
          value={selectedBerthId}
          onChange={(e) => setSelectedBerthId(e.target.value)}
        >
          {berths.map((berth) => (
            <option key={berth.id} value={berth.id}>
              {berth.name}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.section}>
        <div className={styles.categoryLabel}>
          作業予定時間（分）<span className={styles.required}>*</span>
        </div>
        <select
          className={`${styles.select} ${bookingMinute == null ? styles.selectPlaceholder : ''}`}
          value={bookingMinute ?? ''}
          onChange={(e) => {
            const v = e.target.value
            setBookingMinute(v ? Number(v) : null)
          }}
        >
          <option value="">選択してください</option>
          {CALLING_DURATION_OPTIONS.map((min) => (
            <option key={min} value={min}>
              {min}分
            </option>
          ))}
        </select>
      </div>
    </Dialog>
  )
}
